import { TextField } from 'src/shared/entities/control-entities';
import { Directories } from 'src/store/directories/directories.store';

import { TSavedFormValue, TTextFieldRaw } from '../../types';

type TMapTextFieldItemOptions = {
  item: TTextFieldRaw;
  directories: Directories;
  savedValue?: TSavedFormValue;
};

export const mapTextFieldItem = ({ item, directories, savedValue }: TMapTextFieldItemOptions): TextField => {
  const fieldProps = {
    formElementRefId: item.attrName,
    fieldId: item.fieldId,
    validate: item.validate,
    enableIf: item.enableIf,
    visuallyDisabled: item.visuallyDisabled,
    calculatedValue: item.calculatedValue,
    updateDictValue: item.updateDictValue,
    checkDictValue: item.checkDictValue,
    computeTags: item.computeTags,
    additionalConditionalAttributes: item.additionalConditionalAttributes,
    validationTags: item.validationTags,
    useInMainProgressBar: !!item?.useInMainProgressBar,
    required: !!item?.required,
    initialValue: typeof savedValue === 'string' ? savedValue : undefined,
    label: directories.getFieldLabel(item.fieldId) || undefined,
    placeholder: directories.getFieldPlaceholder(item.fieldId) || undefined,
    unit: directories.getFieldUnit(item.fieldId) || item?.item || undefined,
    restrictions: {
      required: !!item.required,
    },
  };

  return new TextField(fieldProps);
};
